import { InputText, InputTextProps } from "primereact/inputtext";
import { InputTextarea, InputTextareaProps } from "primereact/inputtextarea";
import { RefObject, useId } from "react";

export function Input({
  type,
  label,
  resize,
  size,
  className,
  inputClassName,
  ref,
  ...rest
}: {
  resize?: boolean;
  label?: string;
  inputClassName?: string;
  size?: "mini" | "small" | "large";
} & (
  | ({
      type: "text";
      ref?: RefObject<HTMLInputElement | null>;
    } & InputTextProps)
  | ({
      type: "textarea";
      ref?: RefObject<HTMLTextAreaElement | null>;
    } & InputTextareaProps)
)) {
  const id = useId();

  const calculatedInputClassName = `
    ${!resize ? "resize-none" : ""}
    ${size === "mini" ? "!p-0" : ""}
    ${size === "small" ? "!py-1 !px-2" : ""}
    ${size === "large" ? "!py-2 !px-3 !text-xl" : ""}
    ${size === undefined ? "!p-2" : ""}
    ${inputClassName}
  `;

  return (
    <div className={`flex flex-col ${className}`}>
      {label && (
        <label className="text-sm text-gray-500 mb-1" htmlFor={id}>
          {label}
        </label>
      )}
      {type === "text" ? (
        <InputText
          ref={ref}
          className={calculatedInputClassName}
          id={id}
          {...(rest as InputTextProps)}
        />
      ) : (
        <InputTextarea
          ref={ref}
          className={calculatedInputClassName}
          id={id}
          {...(rest as InputTextareaProps)}
        />
      )}
    </div>
  );
}
